import React, { useState } from 'react';
import { ITrainingSet } from '../../../types/my-types';
import SelectModel from './SelectModel';
import { useQueryClient } from '@tanstack/react-query';
import useTrainingSets from '../../hooks/useTrainingSets';

export interface SelectTrainingSetWithSearchProps {
  setTrainingSet: (trainingSet: ITrainingSet | undefined) => void;
  disabled?: boolean;
  currentTrainingSetId?: string;
  inclurrentCurrentTrainingSet?: boolean;
  trainedOnly?: boolean;
  width?: string;
}

const SelectTrainingSetWithSearch: React.FC<SelectTrainingSetWithSearchProps> = ({
  setTrainingSet,
  disabled,
  currentTrainingSetId,
  inclurrentCurrentTrainingSet = true,
  trainedOnly = true,
  width = '100%',
}) => {
  const [search, setSearch] = useState('');

  const trainingSets = useTrainingSets(true, true, search, trainedOnly);
  const queryClient = useQueryClient();
  const cachedData: any = queryClient.getQueryData(['allTrainingSets', {}]);
  const getPages: any = cachedData?.pages;

  let getPagesLength = 0;

  if (getPages && getPages.length > 0) {
    getPagesLength = getPages[0].count;
  }

  let items = trainingSets?.map((ts: ITrainingSet) => ({
    id: ts.id,
    label: ts.label,
  }));

  // Move same model to the beginning of the list
  const sameModel = items.filter((ts) => ts.id === currentTrainingSetId);
  const allModelsWithoutSameModel = items.filter((ts) => ts.id !== currentTrainingSetId);

  if (inclurrentCurrentTrainingSet) {
    items = [...sameModel, ...allModelsWithoutSameModel];
  } else {
    items = allModelsWithoutSameModel;
  }

  const selectTS = (value?: string) => {
    const selectedTrainSet = trainingSets.find((t: ITrainingSet) => t.id === value);
    setTrainingSet(selectedTrainSet);
  };

  // select prev training set as default for re-extract
  // select classifier for create new extraction batch
  return (
    <SelectModel
      setSearch={setSearch}
      style={{ width: width }}
      items={items}
      onChangeCallback={selectTS}
      disabled={disabled}
      defaultValue={currentTrainingSetId}
      loading={trainingSets.length === 0}
      totalItems={getPagesLength}
    />
  );
};

export default SelectTrainingSetWithSearch;
